export const EnumTipoExercicio = () => {
  return [
    { tipo: 'ABDOMINAL', descricao: 'Abdominal' },
    { tipo: 'BARRA', descricao: 'Barra' },
    { tipo: 'FLEXAO', descricao: 'Flexão' },
    { tipo: 'CORRIDA', descricao: 'Corrida' },
  ];
};
